import { render } from "./SectionHeader.vue?vue&type=template&id=57460f5e&scoped=true"
import script from "./SectionHeader.vue?vue&type=script&lang=js"
export * from "./SectionHeader.vue?vue&type=script&lang=js"

import "./SectionHeader.vue?vue&type=style&index=0&id=57460f5e&scoped=true&lang=css"
import "./SectionHeader.vue?vue&type=style&index=1&id=57460f5e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57460f5e"]])

export default __exports__